"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var icon_1 = require("../icon");
var SearchBar = /** @class */ (function (_super) {
    tslib_1.__extends(SearchBar, _super);
    function SearchBar(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setExposedRef = function (el) {
            var exposedRef = _this.props.exposedRef;
            _this.$input = el;
            exposedRef && exposedRef(el);
        };
        _this.onChange = function (e) {
            var onChange = _this.props.onChange;
            if (_this.hasDefaultValue) {
                _this.setState({
                    value: e.target.value
                });
            }
            onChange && onChange(e);
        };
        _this.onClear = function (e) {
            var onClear = _this.props.onClear;
            if (_this.hasDefaultValue) {
                _this.setState({
                    value: ""
                });
                _this.$input.value = "";
            }
            onClear && onClear();
        };
        _this.$input = null;
        _this.state = { value: _this.value };
        return _this;
    }
    Object.defineProperty(SearchBar.prototype, "value", {
        get: function () {
            return this.hasValue ? this.props.value : this.hasDefaultValue ? this.props.defaultValue : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchBar.prototype, "hasValue", {
        get: function () {
            return "value" in this.props;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchBar.prototype, "hasDefaultValue", {
        get: function () {
            return "defaultValue" in this.props;
        },
        enumerable: true,
        configurable: true
    });
    SearchBar.prototype.render = function () {
        var _a, _b;
        var _c = this.props, theme = _c.theme, className = _c.className, inner = _c.inner, small = _c.small, large = _c.large, onChange = _c.onChange, onClear = _c.onClear, fill = _c.fill, light = _c.light, exposedRef = _c.exposedRef, others = tslib_1.__rest(_c, ["theme", "className", "inner", "small", "large", "onChange", "onClear", "fill", "light", "exposedRef"]);
        var classes = classnames_1.default(theme.search, className, (_a = {},
            _a[theme.inner] = inner,
            _a[theme.small] = small,
            _a[theme.large] = large,
            _a[theme.fill] = fill,
            _a[theme.light] = light,
            _a));
        var clearIconClasses = classnames_1.default(theme["clear-icon"], (_b = {},
            _b[theme.show] = (this.state.value || this.value).length > 0,
            _b));
        var searchIconSize = 1.8;
        var clearIconSize = 1;
        if (small) {
            searchIconSize = 1.4;
        }
        else if (large) {
            searchIconSize = 2;
            clearIconSize = 1.2;
        }
        return (React.createElement("div", { className: classes },
            React.createElement("div", { className: theme["search-icon"] },
                React.createElement(icon_1.default, { iconName: "icon-search-small", size: searchIconSize })),
            React.createElement("div", { className: theme.input },
                React.createElement("input", tslib_1.__assign({}, others, { onChange: this.onChange, ref: this.setExposedRef, type: "text" }))),
            React.createElement("div", { className: clearIconClasses, onClick: this.onClear },
                React.createElement(icon_1.default, { iconName: "icon-cancel-small", size: clearIconSize }))));
    };
    SearchBar.defaultProps = {
        placeholder: "Type to search"
    };
    return SearchBar;
}(React.Component));
exports.default = SearchBar;
